import { AttendanceManagementTranslations } from "./attendance-management-pt-br";

export const ATTENDANCE_MANAGEMENT_EN_US: AttendanceManagementTranslations = {
	attendanceManagement: "Attendance Management",
	environmentsAndTables: "Environments and Tables",
	createAndManageEnvironments:
		"Create and manage environments and tables for your establishment.",
	searchByTable: "Search by table",
	statusConfiguration: "Status configuration",
	filter: "Filter",
	tablesInService: "Tables in service",
	tablesNeedingAttention: "Tables needing attention",
	availableTables: "Available tables",
	seeMore: "See more",
	seeAll: "See all",
	selectAll: "Select all",
	loading: "Loading...",
	paid: "Paid",
	statusLabel: {
		Available: "Available",
		InService: "Serving",
		Paid: "Paid",
		InPayment: "In payment",
		Blocked: "Blocked",
	},
	statusDescription: {
		available: "Tables available to be opened",
		inService1: "Tables with service started.",
		inService2: "Tables without interaction since:",
		inPayment: "Tables that have already started payment.",
		blocked: "Tables blocked for reservation or inactivity.",
	},
	minutes: "minutes",
	emptyState: {
		title: "No tables found",
		subtitle: "No tables available with the selected filters.",
	},
	form: {
		minutes: {
			required: "The minutes field is required",
			placeholder: "Enter a value between 1 and 120",
		},
		submit: "Save changes",
		successMessage: "Settings saved successfully",
	},
	updateTimeLabel: "Update time",
	updateTimeValue: "Updated on {{date}} at {{time}}",
	attendanceManagementAlert: {
		title: "Still no event open",
		message:
			"The operation will start after the event is opened and you can track the status of the tables.",
		openEvent: "Open event",
	},
};
